import * as React from "react";
import PropTypes from "prop-types";

import { createComponent } from "@lit-labs/react";

const THEME = {
  colors: {
    primary: "#1982C4",
    secondary: "#1982C4"
  },
  fonts: {
    main: "'Open Sans', Ariel, sans-serif",
    title: "'Open Sans', Ariel, sans-serif",
    titleSize: "18px",
    promotional: "'Open Sans', Ariel, sans-serif",
    promotionalSize: "16px",
  },
  components: {
    container: {
      padding: "24px"
    }
  }
};

let widgetLoad;

const loadVerticalInsure = () => {
  widgetLoad ||= import("@vertical-insure/web-components/legacy").then(
    ({ EventParticipationCancellationInsurance, createTheme }) => ({
      Widget: createComponent({
        tagName: "event-participation-cancellation-insurance",
        elementClass: EventParticipationCancellationInsurance,
        react: React,
        events: {
          onChange: "change",
          onQuoteChange: "quote-change",
          onOfferStateChange: "offer-state-change",
        },
      }),
      theme: JSON.parse(createTheme(THEME)),
    })
  ).catch((error) => {
    widgetLoad = null;
    throw error;
  });
  return widgetLoad;
};

const isUnsupportedBrowserError = (error) => error instanceof SyntaxError && /Invalid regular expression/.test(error.message);

const VerticalInsure = (props) => {
  const [loaded, setLoaded] = React.useState(null);

  React.useEffect(() => {
    let mounted = true;
    loadVerticalInsure()
      .then((result) => mounted && setLoaded(result))
      .catch((error) => {
        if (!isUnsupportedBrowserError(error) && window.Sentry) window.Sentry.captureException(error);
      });
    return () => { mounted = false; };
  }, []);

  if (!loaded) return null;

  const { Widget, theme } = loaded;
  return <Widget theme={theme} {...props} />;
};

VerticalInsure.propTypes = {
  clientId: PropTypes.string.isRequired,
  eventStartDate: PropTypes.string,
  eventEndDate: PropTypes.string,
  state: PropTypes.string,
  postalCode: PropTypes.string,
  insurableAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  participantType: PropTypes.string,
  'data-unique-id': PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  onQuoteChange: PropTypes.func,
  onOfferStateChange: PropTypes.func,
};

VerticalInsure.defaultProps = {
  eventStartDate: null,
  eventEndDate: null,
  state: null,
  postalCode: null,
  insurableAmount: null,
  participantType: null,
  'data-unique-id': null,
  onChange: null,
  onQuoteChange: null,
  onOfferStateChange: null,
};

export default VerticalInsure;
